"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCursorInfo = getCursorInfo;
exports.findNearestStatement = findNearestStatement;
exports.getFieldsFromStatement = getFieldsFromStatement;
exports.findFieldExtraInfo = findFieldExtraInfo;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _ = _interopRequireWildcard(require("lodash"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function getCursorInfo(_x, _x2) {
  return _getCursorInfo.apply(this, arguments);
}

function _getCursorInfo() {
  _getCursorInfo = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee2(rootStatement, keyPath) {
    var cursorValue, cursorKey, parentStatement;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (rootStatement) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", null);

          case 2:
            cursorValue = _.get(rootStatement, keyPath);
            cursorKey = keyPath.slice().pop();
            parentStatement = _.get(rootStatement, keyPath.slice(0, keyPath.length - 1));

            if (parentStatement) {
              _context2.next = 7;
              break;
            }

            return _context2.abrupt("return", null);

          case 7:
            _context2.next = 9;
            return judgeStatement(parentStatement, function () {
              var _ref = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee(typePlusVariant) {
                return _regenerator["default"].wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.t0 = typePlusVariant;
                        _context.next = _context.t0 === 'identifier.tableName' ? 3 : _context.t0 === 'identifier.column' ? 4 : _context.t0 === 'identifier.columnAfterGroup' ? 7 : _context.t0 === 'function' ? 8 : 9;
                        break;

                      case 3:
                        return _context.abrupt("return", {
                          type: 'tableName',
                          variant: cursorKey,
                          token: cursorValue,
                          tableInfo: parentStatement
                        });

                      case 4:
                        if (!(cursorKey === 'name')) {
                          _context.next = 6;
                          break;
                        }

                        return _context.abrupt("return", {
                          type: 'tableField',
                          token: cursorValue
                        });

                      case 6:
                        return _context.abrupt("return", null);

                      case 7:
                        return _context.abrupt("return", {
                          type: 'tableFieldAfterGroup',
                          token: cursorValue,
                          groupName: parentStatement.groupName.value
                        });

                      case 8:
                        return _context.abrupt("return", {
                          type: 'functionName',
                          token: cursorValue
                        });

                      case 9:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x20) {
                return _ref.apply(this, arguments);
              };
            }());

          case 9:
            return _context2.abrupt("return", _context2.sent);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getCursorInfo.apply(this, arguments);
}

function findNearestStatement(rootStatement, keyPath, callback) {
  if (!rootStatement) {
    return null;
  }

  if (keyPath.length === 0) {
    return null;
  }

  var value = _.get(rootStatement, keyPath);

  if (!value) {
    throw Error('Path not found from ast!');
  }

  if (!value.token && value.type === 'statement') {
    if (callback) {
      if (callback(value) === true) {
        return value;
      }
    } else {
      return value;
    }
  }

  if (keyPath.length > 1) {
    return findNearestStatement(rootStatement, keyPath.slice(0, keyPath.length - 1), callback);
  }

  return null;
}

function getFieldsFromStatement(_x3, _x4, _x5) {
  return _getFieldsFromStatement.apply(this, arguments);
}

function _getFieldsFromStatement() {
  _getFieldsFromStatement = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee3(rootStatement, cursorKeyPath, getFieldsByTableName) {
    var cursorInfo, cursorRootStatement, parentCursorKeyPath, parentSelectStatement;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getCursorInfo(rootStatement, cursorKeyPath);

          case 2:
            cursorInfo = _context3.sent;
            cursorRootStatement = findNearestStatement(rootStatement, cursorKeyPath);

            if (cursorRootStatement) {
              _context3.next = 6;
              break;
            }

            return _context3.abrupt("return", []);

          case 6:
            _context3.t0 = cursorRootStatement.variant;
            _context3.next = _context3.t0 === 'select' ? 9 : _context3.t0 === 'join' ? 10 : 14;
            break;

          case 9:
            return _context3.abrupt("return", getFieldsByFromClauses(cursorRootStatement, _.get(cursorRootStatement, 'from.sources', []), cursorInfo, getFieldsByTableName));

          case 10:
            parentCursorKeyPath = cursorKeyPath.slice();
            parentCursorKeyPath.pop();
            parentSelectStatement = findNearestStatement(rootStatement, parentCursorKeyPath, function (eachStatement) {
              return eachStatement.variant === 'select';
            });
            return _context3.abrupt("return", getFieldsByFromClauses(parentSelectStatement, _.get(parentSelectStatement, 'from.sources', []), cursorInfo, getFieldsByTableName));

          case 14:
            return _context3.abrupt("return", []);

          case 15:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getFieldsFromStatement.apply(this, arguments);
}

function getFieldsByFromClauses(_x6, _x7, _x8, _x9) {
  return _getFieldsByFromClauses.apply(this, arguments);
}

function _getFieldsByFromClauses() {
  _getFieldsByFromClauses = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee4(rootStatement, fromStatements, cursorInfo, getFieldsByTableName) {
    var fields;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return Promise.all(fromStatements.map(function (fromStatement) {
              return getFieldsByFromClause(rootStatement, fromStatement, cursorInfo, getFieldsByTableName);
            }));

          case 2:
            fields = _context4.sent;
            return _context4.abrupt("return", _.flatten(fields).filter(function (item) {
              return !!item;
            }));

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getFieldsByFromClauses.apply(this, arguments);
}

function getFieldsByFromClause(_x10, _x11, _x12, _x13) {
  return _getFieldsByFromClause.apply(this, arguments);
}

function _getFieldsByFromClause() {
  _getFieldsByFromClause = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee6(rootStatement, fromStatement, cursorInfo, getFieldsByTableName) {
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", judgeStatement(fromStatement, function () {
              var _ref2 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee5(typePlusVariant) {
                var tableSourceFields, joinsFields, itFromStatement, originFields, tableNames, groupPickerName, tableNameAlias, existKeyCount, ssFromStatement, statementSelectFields, fields;
                return _regenerator["default"].wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.t0 = typePlusVariant;
                        _context5.next = _context5.t0 === 'statement.tableSource' ? 3 : _context5.t0 === 'statement.join' ? 15 : _context5.t0 === 'identifier.table' ? 16 : _context5.t0 === 'statement.select' ? 26 : 34;
                        break;

                      case 3:
                        _context5.next = 5;
                        return getFieldsByFromClause(rootStatement, fromStatement.source, cursorInfo, getFieldsByTableName);

                      case 5:
                        tableSourceFields = _context5.sent;

                        if (!_.isArray(fromStatement.joins)) {
                          _context5.next = 12;
                          break;
                        }

                        _context5.next = 9;
                        return getFieldsByFromClauses(rootStatement, _.get(fromStatement, 'joins', []), cursorInfo, getFieldsByTableName);

                      case 9:
                        _context5.t1 = _context5.sent;
                        _context5.next = 13;
                        break;

                      case 12:
                        _context5.t1 = [];

                      case 13:
                        joinsFields = _context5.t1;
                        return _context5.abrupt("return", tableSourceFields.concat(joinsFields));

                      case 15:
                        return _context5.abrupt("return", getFieldsByFromClause(rootStatement, fromStatement.join, cursorInfo, getFieldsByTableName));

                      case 16:
                        itFromStatement = fromStatement;
                        _context5.next = 19;
                        return getFieldsByTableName(itFromStatement.name, cursorInfo.token.value, rootStatement);

                      case 19:
                        originFields = _context5.sent;
                        tableNames = _.get(itFromStatement, 'name.tableNames', []);
                        groupPickerName = null;
                        tableNameAlias = _.get(itFromStatement, 'alias.value');

                        if (tableNameAlias) {
                          groupPickerName = tableNameAlias;
                        } else {
                          existKeyCount = 0;
                          tableNames.forEach(function (tableName) {
                            var eachTableName = _.get(itFromStatement, "name.".concat(tableName, ".value"));

                            if (eachTableName) {
                              existKeyCount++;
                              groupPickerName = eachTableName;
                            }
                          });

                          if (existKeyCount > 1) {
                            groupPickerName = null;
                          }
                        }

                        originFields = originFields.map(function (originField) {
                          return _objectSpread({}, originField, {
                            tableInfo: itFromStatement.name,
                            groupPickerName: groupPickerName,
                            originFieldName: originField.label
                          });
                        });
                        return _context5.abrupt("return", originFields);

                      case 26:
                        ssFromStatement = fromStatement;
                        statementSelectFields = [];
                        _context5.next = 30;
                        return getFieldsByFromClauses(ssFromStatement, ssFromStatement.from.sources, cursorInfo, getFieldsByTableName);

                      case 30:
                        fields = _context5.sent;

                        if (ssFromStatement.result.length === 1 && ssFromStatement.result[0].name.value === '*') {
                          statementSelectFields = fields.slice();
                        } else {
                          statementSelectFields = fields.map(function (field) {
                            var selectedField = ssFromStatement.result.find(function (result) {
                              if (_.get(result.name, 'token') === true) {
                                return result.name.value === field.label;
                              }

                              if (_.get(result.name, 'type') === 'identifier' && _.get(result.name, 'variant') === 'columnAfterGroup') {
                                return _.get(result.name, 'name.value') === field.label;
                              }

                              if (_.get(result.name, 'type') === 'identifier' && _.get(result.name, 'variant') === 'groupAll') {
                                return _.get(result.name, 'groupName.value') === field.groupPickerName;
                              }

                              return false;
                            });

                            if (!selectedField) {
                              return null;
                            }

                            if (selectedField.alias) {
                              return _objectSpread({}, field, {
                                label: selectedField.alias.value
                              });
                            }

                            return field;
                          }).filter(function (field) {
                            return field !== null;
                          }).slice();
                        }

                        if (_.has(ssFromStatement, 'alias.value')) {
                          statementSelectFields = statementSelectFields.map(function (statementSelectField) {
                            return _objectSpread({}, statementSelectField, {
                              groupPickerName: _.get(ssFromStatement, 'alias.value')
                            });
                          });
                        }

                        return _context5.abrupt("return", statementSelectFields);

                      case 34:
                        return _context5.abrupt("return", null);

                      case 35:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              }));

              return function (_x21) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getFieldsByFromClause.apply(this, arguments);
}

function judgeStatement(_x14, _x15) {
  return _judgeStatement.apply(this, arguments);
}

function _judgeStatement() {
  _judgeStatement = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee7(statement, callback) {
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (statement) {
              _context7.next = 2;
              break;
            }

            return _context7.abrupt("return", null);

          case 2:
            if (!statement.variant) {
              _context7.next = 4;
              break;
            }

            return _context7.abrupt("return", callback("".concat(statement.type, ".").concat(statement.variant)));

          case 4:
            return _context7.abrupt("return", callback(statement.type));

          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _judgeStatement.apply(this, arguments);
}

function findFieldExtraInfo(_x16, _x17, _x18, _x19) {
  return _findFieldExtraInfo.apply(this, arguments);
}

function _findFieldExtraInfo() {
  _findFieldExtraInfo = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee8(rootStatement, cursorInfo, getFieldsByTableName, fieldKeyPath) {
    var fields, field;
    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return getFieldsFromStatement(rootStatement, fieldKeyPath, getFieldsByTableName);

          case 2:
            fields = _context8.sent;
            field = fields.find(function (eachField) {
              return eachField.label === cursorInfo.token.value;
            });

            if (field) {
              _context8.next = 6;
              break;
            }

            return _context8.abrupt("return", null);

          case 6:
            return _context8.abrupt("return", field);

          case 7:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _findFieldExtraInfo.apply(this, arguments);
}